<template>
	<div class="overflow-remove contact-page-bg" style="overflow:auto;height:100vh;">
		<div v-if="pageLoader" class="loader1">
			<div>
				<div class="lds-ripple">
				<div></div>
				<div></div>
				</div>
			</div>
		</div>
		<div class="text-left contact-information-stepper w-100">
			<div v-if="checkAuth" class="authSection">
				<div class="row">
					<div class="col-3"></div>
					<div class="col-6">
						<div v-if="!strictWarning" class="assessmentdiv">
							<h4>Login</h4>
							<div class="assessmentdivbody">
								<b-form @submit.stop.prevent="masterLoginProcess">
									<b-form-group label="Email" label-for="form-email" class="text-left">
										<b-form-input
											id="form-email"
											v-model="form.email"
											type="email"
											required
											placeholder="name@example.com"
										/>
									</b-form-group>
									<b-form-group label="Password" label-for="form-password" class="text-left">
										<b-form-input
											id="form-password"
											v-model="form.password"
											type="password"
											required
										/>
									</b-form-group>
									<p class="text-danger">{{error}}</p>
									<div class="AuthLoginBtn">
										<b-button v-if="!checkAuthLoader" type="submit" variant="outline-primary">Log in</b-button>
										<b-button v-if="checkAuthLoader" variant="outline-primary"><div class="loader4"></div></b-button>
									</div>
								</b-form>
							</div>
						</div>

						<div v-if="strictWarning" class="AccessDeniedDiv assessmentdiv">
							<h4>Access Denied</h4>
							<div class="assessmentdivbody">
								Sorry, you don't have access. Please contact the administrator.
							</div>
						</div>
					</div>
					<div class="col-3"></div>
				</div>
			</div>
			<div @click="downloadPDF()" style="display:none;">Download PDF</div>
			<div v-if="!checkAuth">
				<div class="masterReportHead">Master Report </div>
				<div class="masterReportTitle">
					<b-button-group class="col-sm-2 filter-btn">
						<b-button class="createStartReport" variant="outline-primary" @click="$bvModal.show('CreateStartReport')">Create a Stat Report</b-button>
					</b-button-group>
				</div>
				
			
				<!-- <div class="container-fluid">
					<div class="filterSectionDiv">
						<b-form class="p-3 row align-items-center">
							<b-form-group label="Start Date" class="text-left col-sm-3 start-date">
								<b-form-group>
									<b-form-datepicker
										v-model="form.date_s"
										size="sm"
										required/>
								</b-form-group>
							</b-form-group>
							<b-form-group label="End Date" class="text-left col-sm-3 end-date">
								<b-form-group class="date_picker_add">
									<b-form-datepicker 
										v-model="form.date_e"
										size="sm"
										required/>
								</b-form-group>
							</b-form-group>
							<b-button-group class="w-100 col-sm-6 filter-btn">
								<vue-multi-select
								ref="multiSelect"
								class="multiSelectdiv"
								:options="options11"
								:btnLabel="CheckboxLabel"
								:selectOptions="checkboxDataWithFilterDropdown">
								<template v-slot:option="{option}">
									
									<label :for='option.id' v-if="option.hasOwnProperty('stype')"
									style="width: 100%; margin-bottom: 0px;padding:5px; font-size:14px;">
									<input type="checkbox" 
									:id="option.id" 
									:value="option.id" 
									@change="checkFilterBySource($event)"
									> {{option.name}}</label>
									
									<label :for='option.pbid' v-if="option.hasOwnProperty('ptype')"
									style="width: 100%; margin-bottom: 0px;padding:5px; font-size:14px;">
									<input type="checkbox" 
									:id="option.pbid" 
									:value="option.pbid" 
									@change="checkFilterByPublisher($event)"
									> {{option.name}}</label>

									<label :for='option.did' v-if="option.hasOwnProperty('dtype')"
									style="width: 100%; margin-bottom: 0px;padding:5px; font-size:14px;">
									<input type="checkbox" 
									:id="option.did" 
									:value="option.did"
									@change="checkFilterByDevice($event)"
									> {{option.name}}</label>
									
									<label :for='option.cid' v-if="option.hasOwnProperty('ctype')"
									style="width: 100%; margin-bottom: 0px;padding:5px; font-size:14px;">
									<input type="checkbox" 
									:id="option.cid" 
									:value="option.cid"
									@change="checkFilterByCompany($event)"
									> {{option.name}}</label>
								
								</template>
							</vue-multi-select>
								<b-button v-if="!filterClicked" variant="outline-primary" @click="applyFilterTemp" style="border-radius: 3px;"> 
									<div>Run Report</div> 
								</b-button>
								<b-button v-if="filterClicked" variant="outline-primary" style="border-radius: 3px;width:90px;padding-left: 5px;"> 
									<div class="col-sm-12 text-center loader-blue" style="position: absolute; padding-left: 0;text-align: left!important;margin-right:-12px;">
										<div class="loader4"></div>
									</div>
								</b-button>
								<b-button class="createStartReport" variant="outline-primary" @click="$bvModal.show('CreateStartReport')">Create a Stat Report</b-button>
							</b-button-group>

						</b-form>
					</div>
				</div> -->
				<!-- <div class="container-fluid">
					<div class="col-md-12">
						<div class="">
							<div class="row">
								<div class="col-lg-3">
									<div class="tilesDiv">
										<div class="card tatext-card-layout text-c-blue">
											<div class="tilesBodyDiv">
												<h6>ThirdPool Prospects</h6>
												<h3>{{ThirdPoolProspectsCount}}</h3>
											</div>
										</div>
									</div>
								</div>
								<div class="col-lg-3">
									<div class="tilesDiv">
										<div class="card tatext-card-layout text-c-blue">
											<div class="tilesBodyDiv">
												<h6>Organic Prospects</h6>
												<h3>{{OrganicProspectsCount}}</h3>
											</div>
										</div>
									</div>
								</div>
								<div class="col-lg-3">
									<div class="tilesDiv">
										<div class="card tatext-card-layout text-c-blue">
											<div class="tilesBodyDiv">
												<h6>Completed Questionnaires</h6>
												<h3>{{QuestionnaireProspectsCount}}</h3>
											</div>
										</div>
									</div>
								</div>
								<div class="col-lg-3">
									<div class="tilesDiv">
										<div class="card tatext-card-layout text-c-blue">
											<div class="tilesBodyDiv">
												<h6>Interviews</h6>
												<h3>{{InterviewsCount}}</h3>
											</div>
										</div>
									</div>
								</div>
								<div class="col-lg-3">
									<div class="tilesDiv">
										<div class="card tatext-card-layout text-c-blue">
											<div class="tilesBodyDiv">
												<h6>Average Interview Rating</h6>
												<h3>{{FinalInterviewAverage}}</h3>
											</div>
										</div>
									</div>
								</div>
								<div class="col-lg-3">
									<div class="tilesDiv">
										<div class="card tatext-card-layout text-c-blue">
											<div class="tilesBodyDiv">
												<h6>Hires</h6>
												<h3>{{HiredCount}}</h3>
											</div>
										</div>
									</div>
								</div>
								<div class="col-lg-3">
									<div class="tilesDiv">
										<div class="card tatext-card-layout text-c-blue">
											<div class="tilesBodyDiv">
												<h6>Completed CCI</h6>
												<h3>{{CCICount}}</h3>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-4">
									<div>
										<apexcharts width="360" type="bar" :options="prospectStageOptions" :series="prospectStageSeries"></apexcharts>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div> -->
				<b-modal id="CreateStartReport" hide-footer>
					<template v-slot:modal-title>
						Generate and Download Report
					</template>
					<div class="TabSectionManage">
						<b-form>
							<b-form-group label="Company:">
                                <b-form-select v-model="companyField" @change="onChangePopupCompany">
                                    <b-form-select-option :value="null">Please Select Company</b-form-select-option>
                                    <option :value="uof1.uid" :key="uof1.uid" v-for="uof1 in popupCompanyList">{{uof1.company}}</option>
                                </b-form-select>
                            </b-form-group>
							<b-form-group label="Nickname:" class="text-left">
								<b-form-input class="nickNamefield" placeholder="Enter ..." v-model="nickName" required />
							</b-form-group>
							<b-form-group label="Month:">
								<b-form-select v-model="month" :options="monthoptions"></b-form-select>
							</b-form-group>
							<b-form-group label="Year:">
								<b-form-select v-model="year" :options="yearoptions"></b-form-select>
							</b-form-group>
							<b-form-group label="Projected Hires:">
								<b-form-input
								type="number"
								class="nickNamefield"
								v-model="projectedHireField"
								placeholder="Enter ..."
								/>
							</b-form-group>
							<div class="GenerateReportDiv">
								<b-button block variant="outline-primary" @click="GenerateReportPDFForm">Generate Report</b-button>
							</div>
						</b-form>
					</div>

				</b-modal>
			</div>
		</div>

		<vue-html2pdf
		:show-layout="false"
		:filename="makePDFFileName"
		:paginate-elements-by-height="2000"
		ref="html2Pdf"
		>
			<section slot="pdf-content">
				<div class="PDFSectionDiv" style="color:#5e5e5e;">
					<div style="background: #1e5577; color: #fff; padding: 10px;">
						<div><img src="../../../public/img/psdlogo.png" style="width:17%; margin: 10px 0px 5px 0px;"/></div>
						<div style="margin: 0px;font-size: 26px; font-weight: 600;">{{nickName}}</div>
						<p style="text-transform: uppercase;padding: 5px 0px; margin: 0px;letter-spacing: 3.5px;">Recruiting Performance {{getMonthName(month)}} {{year}}</p>
					</div>
					<div class="row" style="background: #fff;margin: 0px;">
						<div class="col-md-6" style="float: left; width: 50%; padding-right: 0px;">
							<div class="leftTopSectionOne" style="background: #1e5577; padding:3px 5px; margin: 15px 15px;">
								<div style="font-size: 18px; text-align: center; margin: 5px 0px 10px 0px!important; color:#fff;">This Month's Sourcing Results</div>
								<div class="row" style="margin:1px;">
									<div class="col-md-4" style="padding: 0px;float: left;">
										<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; text-align: center; clear: both;">
										<h3 style="margin: 0px; font-size: 20px; font-weight: 600;">{{PDFThirdPoolProspectsCount}}</h3>
										<h6 style="margin: 0px; font-size: 14px;">Thirdpool <br> Sourced</h6>
										</div>
									</div>
									<div class="col-md-4" style="padding: 0px;width: 33.33333333%; float: left; visibility: hidden;">
										<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; text-align: center; clear: both;">
										<h3 style="margin: 0px; font-size: 20px; font-weight: 600;">0</h3>
										<h6 style="margin: 0px; font-size: 14px;">Name <br> Here</h6>
										</div>
									</div>
									<div class="col-md-4" style="padding: 0px;width: 33.33333333%; float: left;">
										<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; text-align: center; clear: both;">
										<h3 style="margin: 0px; font-size: 20px; font-weight: 600;">{{PDFOrganicProspectsCount}}</h3>
										<h6 style="margin: 0px; font-size: 14px;">Organically Sourced</h6>
										</div>
									</div>
									<div class="col-md-4" style="padding: 0px;width: 33.33333333%; float: left;">
										<div class="boxes" style="padding-top: 4px;text-align:center;">
										<img src="../../../public/img/Group-34899.png" style="width:45%;" />
										</div>
									</div>
									<div class="col-md-4" style="padding: 0px;width: 33.33333333%; float: left;">
										<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; text-align: center; clear: both;">
										<h3 style="margin: 0px; font-size: 20px; font-weight: 600;">{{PDFSourceCount}}</h3>
										<h6 style="margin: 0px; font-size: 14px;">Recruiting Prospects</h6>
										</div>
									</div>
									<div class="col-md-4" style="padding: 0px;width: 33.33333333%; float: left;">
										<div class="boxes" style="padding-top: 4px; text-align:center;">
										<img src="../../../public/img/Group-34898.png" style="width:45%;" />
										</div>
									</div>
									<div class="col-md-4" style="padding: 0px;width: 33.33333333%; float: left; clear:both;">
										<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; text-align: center; clear: both;">
										<h3 style="margin: 0px; font-size: 20px; font-weight: 600;">{{totalInboundMessageCount}}</h3>
										<h6 style="margin: 0px; font-size: 14px;">Responsive / Engaged</h6>
										</div>
									</div>
									<div class="col-md-4" style="padding: 0px;width: 33.33333333%; float: left; visibility: hidden;">
										<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; text-align: center; clear: both;">
										<h3 style="margin: 0px;">0</h3>
										<h6 style="margin: 0px; font-size: 14px;">Name <br> Here</h6>
										</div>
									</div>
									<div class="col-md-4" style="padding: 0px;width: 33.33333333%; float: left; ">
										<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; text-align: center; clear: both;">
										<h3 style="margin: 0px; font-size: 20px; font-weight: 600;">
											<span v-if="totalInboundMessageCount">{{(PDFSourceCount - totalInboundMessageCount)}}</span>
											<span v-else>{{totalOutBoundMessageCount}}</span>
										</h3>
										<h6 style="margin: 0px; font-size: 14px;">Screened <br> Out</h6>
										</div>
									</div>
								</div>
								<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; text-align: center; clear: both;font-size: 11px;">
									Messages Sent/Received By Recruiting Coordinator: {{this.sumOfInbound + this.sumOfOutbound}}
								</div>
							</div>
							<div class="leftTopSectionOne" style="background: #1e5577; padding:3px 5px; margin: 15px 15px;">
								<div class="row1" style="display: inline-block; width: 100%;font-size: 11px;">
									<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: center;">
										<div class="col-md-4" style="width: 33.33333333%; float: left;">
										<div>Exploring <br> {{pTag1}}%</div>
										</div>
										<div class="col-md-4" style="width: 33.33333333%; float: left;">
										<div>In-School <br> {{pTag2}}%</div>
										</div>
										<div class="col-md-4" style="width: 33.33333333%; float: left;">
										<div>Licensed <br> {{pTag3}}%</div>
										</div>
									</div>
								</div>
							</div>
							<div class="leftTopSectionOne" style="background: #1e5577; padding:3px 5px; margin: 15px 15px;">
								<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; text-align: center; clear: both;">
									<div class="row1" style="display: inline-block; width: 100%;font-size: 11px;">
										<div class="col-md-12" style="width:100%; clear: both;">
										<div style="margin-bottom: 10px;">Advertising Cost Per Recruiting Prospect</div>
										</div>
										<div class="col-md-6" style="float: left; width: 50%;">
										<div style="margin: 0px 10px;">Your Company <br> ${{PDFAdCostYourCompany}}</div>
										</div>
										<div class="col-md-6" style="float: left; width: 50%;border-left: 4px solid #ddd;">
										<div style="margin: 0px 10px;">National Average <br> ${{AdCostNationalAverage}}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="leftTopSectionOne" style="padding:3px 5px; margin: 20px 20px 15px 15px;">
								<div style="text-align: center; font-weight: 600; margin-bottom: 30px;">
									<div style="font-size: 16px;">Your ThirdPool Recruiting Pipeline</div>
									<div style="font-size: 16px;">(Month-End Snapshot)</div>
								</div>
								<div style="position: relative;">
									<img src="../../../public/img/pdf-pipeline.png" width="100%" />
									<span style="position: absolute; top: 5%; left: 14%; color: #FFF; width: 11%; font-size: 18px;text-align:center;">{{leftPad((PipePDFStatusPreInt + PipePDFStatusPostInt + PipePDFStatusOff), 2)}}</span>
									<span style="position: absolute; top: 37%; left: 18%; color: #FFF; font-size: 16px;width: 11%;text-align:center;">{{leftPad(PipePDFStatusPreInt, 2)}}</span>
									<span style="position: absolute; top: 44%; left: 45%; color: #FFF; font-size: 16px;width: 11%;text-align:center;">{{leftPad(PipePDFStatusPostInt, 2)}}</span>
									<span style="position: absolute; top: 50%; right: 19%; color: #FFE; font-size: 16px;width: 11%;text-align:center;">{{leftPad(PipePDFStatusOff, 2)}}</span>
								</div>
							</div>
						</div>
						<div class="col-md-6" style="float: left; width: 50%; padding-left: 0px;">
							<div class="row" style="">
								<div class="col-md-12" style="width:100%; clear: both;">
									<div class="leftTopSectionOne" style="background: #1e5577; padding:3px 5px; margin: 15px 15px 0px 15px;">
										<div style="font-size: 18px; text-align: center; margin: 5px 0px 10px 0px!important; color:#fff;">This Month's Recruiting Results</div>
										<div class="row1" style="display: inline-block; width: 100%;font-size: 11px;">
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-8" style="width: 66.66666667%; float: left;">Interviews Completed</div>
												<div class="col-md-4" style="width: 33.33333333%; float: left;text-align: center;">{{mPDFInterviewesCompleted}}</div>
											</div>
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-8" style="width: 66.66666667%; float: left;">Added to Pipeline</div>
												<div class="col-md-4" style="width: 33.33333333%; float: left;text-align: center;">{{(PDFStatusPreInt + PDFStatusPostInt + PDFStatusOff)}}</div>
											</div>
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-8" style="width: 66.66666667%; float: left;">Lost to Competitors</div>
												<div class="col-md-4" style="width: 33.33333333%; float: left;text-align: center;">{{mPDFLTCCount}}</div>
											</div>
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-8" style="width: 66.66666667%; float: left;">Hires</div>
												<div class="col-md-4" style="width: 33.33333333%; float: left;text-align: center;">{{mPDFHiredCount}}</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-12" style="width:100%; clear: both;">
									<div class="leftTopSectionOne" style="background: #1e5577; padding:3px 5px; margin: 15px 15px 0px 15px;">
										<div style="font-size: 18px; text-align: center; margin: 5px 0px 10px 0px!important; color:#fff;">This Year's Recruiting Results</div>
										<div class="row1" style="display: inline-block; width: 100%;font-size: 11px;">
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-8" style="width: 66.66666667%; float: left;">Interviews Completed</div>
												<div class="col-md-4" style="width: 33.33333333%; float: left;text-align: center;">{{yPDFInterviewesCompleted}}</div>
											</div>
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-8" style="width: 66.66666667%; float: left;">Added Pipeline</div>
												<div class="col-md-4" style="width: 33.33333333%; float: left;text-align: center;">{{(yPDFStatusPreInt + yPDFStatusPostInt + yPDFStatusOff)}}</div>
											</div>
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-8" style="width: 66.66666667%; float: left;">Lost to Competitor</div>
												<div class="col-md-4" style="width: 33.33333333%; float: left;text-align: center;">{{yPDFLTCCount}}</div>
											</div>
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-8" style="width: 66.66666667%; float: left;">Hires</div>
												<div class="col-md-4" style="width: 33.33333333%; float: left;text-align: center;">{{yPDFHiredCount}}</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-12" style="width:100%; clear: both;">
									<div class="leftTopSectionOne" style="background: #1e5577; padding:3px 5px; margin: 15px 15px 0px 15px;">
										<div style="font-size: 18px; text-align: center; margin: 5px 0px 10px 0px!important; color:#fff;">Recruiting Performance Metrics</div>
										<div class="row1" style="display: inline-block; width: 100%;font-size: 11px;">
											<div style="display: flex;text-align: left;">
												<div class="col-md-6" style="float: left; width: 50%;"></div>
												<div class="col-md-3" style="width: 25%; color: #fff; font-weight: 500;text-align: center;">Your Company</div>
												<div class="col-md-3" style="width: 25%; color: #fff; font-weight: 500;text-align: center;">National Average</div>
											</div>
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-6" style="float: left; width: 50%;">Interview Rate</div>
												<div class="col-md-3" style="width: 25%;text-align: center;">{{PDFInterviewRateYour}}%</div>
												<div class="col-md-3" style="width: 25%;text-align: center;">{{yPDFNAInterviewRate}}%</div>
											</div>
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-6" style="float: left; width: 50%;">Interview No Show Rate</div>
												<div class="col-md-3" style="width: 25%;text-align: center;">{{PDFInterviewNoShowRate}}%</div>
												<div class="col-md-3" style="width: 25%;text-align: center;">{{yPDFNAInterviewNoShowRate}}%</div>
											</div>
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-6" style="float: left; width: 50%;">Hire Rate</div>
												<div class="col-md-3" style="width: 25%;text-align: center;">{{PDFHiredRateYour}}%</div>
												<div class="col-md-3" style="width: 25%;text-align: center;">{{yPDFNAHiredRate}}%</div>
											</div>
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-6" style="float: left; width: 50%;">Lost to Competitor Rate</div>
												<div class="col-md-3" style="width: 25%;text-align: center;">{{PDFLTCRateYour}}%</div>
												<div class="col-md-3" style="width: 25%;text-align: center;">{{yPDFNALTCRate}}%</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-12" style="width:100%; clear: both;">
									<div class="leftTopSectionOne" style="background: #1e5577; padding:3px 5px; margin: 15px 15px 0px 15px;">
										<div style="font-size: 18px; text-align: center; margin: 5px 0px 10px 0px!important; color:#fff;">Projected Sourcing Cost Per Hire</div>
										<div class="row1" style="display: inline-block; width: 100%;font-size: 11px;">
											<div style="display: flex;text-align: left;">
												<div class="col-md-6" style="float: left; width: 50%;"></div>
												<div class="col-md-3" style="width: 25%; color: #fff; font-weight: 500;text-align: center;">Your Company</div>
												<div class="col-md-3" style="width: 25%; color: #fff; font-weight: 500;text-align: center;">National Average</div>
											</div>
											<div class="boxes" style="background: #fff; padding: 7px 0px; margin: 5px; clear: both;display: flex;text-align: left;">
												<div class="col-md-6" style="float: left; width: 50%;">Sourcing Cost Per Hire</div>
												<div class="col-md-3" style="width: 25%;text-align: center;">${{PDFSourcingCostYC}}</div>
												<div class="col-md-3" style="width: 25%;text-align: center;">${{SourcingCostNationalAverage}}</div>
											</div>
										</div>
									</div>
								</div>
								<div style="padding: 60px 0px 20px 0px; font-size: 24px;width: 100%;line-height: 35px;">
									<div>
										<img src="../../../public/img/arrow-right.png" style="width: 25%;
										float: left;margin-left: -70px; margin-top: -20px;transform: rotate(20deg);"/>
									</div>
									<div style="padding-left: 90px;float: left;">This Year's</div>
									<div style="padding-left: 60px;float: left;">
										Projected Hires
										<div style="font-weight: 600; font-size: 40px;float: right; padding-left: 12px;position: relative;">
											<div style="position: absolute;top:-20px;">
												<div v-if="projectedHireField">{{projectedHireField}}</div>
												<div v-else>{{projectedHire}}</div>
											</div>
										</div>	
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</vue-html2pdf>

	</div>
</template>
<script>
	import VueHtml2pdf from 'vue-html2pdf'
	// import vueMultiSelect from 'vue-multi-select';
	import 'vue-multi-select/dist/lib/vue-multi-select.css';
	import { auth } from 'src/db.js'
    import { db } from 'src/db'
	// import VueApexCharts from 'vue-apexcharts'
	import { mapState } from 'vuex'
	import axios from "axios";
	import moment from 'moment';
	export default {
		name: "MasterReport",
		components: {
			// apexcharts: VueApexCharts,
			// vueMultiSelect,
			VueHtml2pdf
		},
		computed: {
			// COMPANY NAME LIST IN POPUP
			popupCompanyList() {
                let aa = [];
                Object.assign(aa,this.companyUserList);
				return aa.sort(function(a, b){ return (a.company > b.company) ? 1 : -1;});
            },
			...mapState('firebase', ['alluser', 'teams'])
        },
		created() {
			if(auth.currentUser) {
				this.onLoadCheckAuthPermission();
				this.checkAuth = false;
			}
			this.FilterByOfficesManagers();
			this.companyUserDropdownList();
		},
		methods: {
			// UPDATE IDs IN TEAM FOR PDF REPORT PURPOSE (AUTH PURPOSE)
			async updateTeamIDTempScript() {
				if(this.teams.hasOwnProperty('B2ZK14pbXwPIyDDg7iGZw1UQaw03') || this.teams.hasOwnProperty('SHh5DR0PULYnAHHlAR5J3S2QKFt1')) {
					var dataa = {
						Teams: this.cUid
					}
					//eslint-disable-next-line
					console.log("dataa11", dataa);
					db.doc(`Team/zzxOvpZGle9GsNlZqisB`).update({ B2ZK14pbXwPIyDDg7iGZw1UQaw03: dataa });
					db.doc(`Team/zzxOvpZGle9GsNlZqisB`).update({ SHh5DR0PULYnAHHlAR5J3S2QKFt1: dataa });
				}
			},
			async calInOutData() {
				var dd;
				if(this.getCurrentCompanyDetail.prospData.length && this.convoCollectionData.length) {
					this.getCurrentCompanyDetail.prospData.forEach(element=>{
						if(element.DateCreated && (element.DateCreated >= this.convertselectedMonthFirstDay && element.DateCreated <= this.convertselectedMonthLastDay)) {
							this.convoCollectionData.forEach(elementconvos => {
								if(elementconvos.ClientNumber == element.Number) {
									dd = this.CalculateInboundOutbound(elementconvos.id);
								}
							});
						}
					});
				}
				return dd;
			},
			async calInOutData2() {
				var dd;
				if(this.getCurrentCompanyDetail.prospData.length && this.convoCollectionData.length) {
					this.getCurrentCompanyDetail.prospData.forEach(element=>{
						this.convoCollectionData.forEach(elementconvos => {
							if(elementconvos.ClientNumber == element.Number && (elementconvos.DateUpdated >= this.convertselectedMonthFirstDay) && elementconvos.DateUpdated <= this.convertselectedMonthLastDay) {
								dd = this.CalculateInboundOutbound2(elementconvos.id);
							}
						});
					});
				}
				return dd;
			},
			async basedOnUserCountConvos() {
				let convoRef = await db.collection(`Conversations`).where('Uid', "==" , this.companyField).orderBy('DateUpdated', 'desc').get();
				var convoRefLength = convoRef.docs.length;
				if(convoRefLength) {
					this.convoCollectionData = convoRef.docs.map((doc) => {
						let data1 = { id: doc.id, ...doc.data() };
						return data1;
					});
					//eslint-disable-next-line
					console.log("convoCollectionData 560:", this.convoCollectionData);
					//eslint-disable-next-line
					console.log("getCurrentCompanyDetail 562:", this.getCurrentCompanyDetail);
					await this.calInOutData();
					await this.calInOutData2();
				}
			},
			// SELECT COMPANY FOR PDF REPORT
			async fetchPDFDataSelectedUser() {

				var aa1 = await this.commonQuery(this.companyField);

				/*var userQuery1 = await db.collection(`Users`).where("Uid", "==", this.companyField).get();
				let userQueryData1 = userQuery1.docs.map((doc) => {
					let data = { id: doc.id, uid:doc.data().Uid, first: doc.data().First, last: doc.data().Last, company: doc.data().Company, version: doc.data().Version, benchmark: doc.data().Benchmark, MonthlyAdCost: doc.data().MonthlyAdCost, MonthlyTotalCost: doc.data().MonthlyTotalCost, prospData:{}};
					return data;
				})

				//eslint-disable-next-line
				console.log("userQueryData1", userQueryData1);

				var finalArray1 = await Promise.all(userQueryData1.map(async(element) => {
					var proRef1Test = await db.collection(`Users/${element.id}/Prospects`).get();
					var MergeProspectData = [];
					proRef1Test.docs.map((doc) => {
						
						var ProspectData = {};

						ProspectData = {...ProspectData, "Pid": doc.id}; 
						ProspectData = {...ProspectData, "DateCreated": doc.data().DateCreated};
						ProspectData = {...ProspectData, "Source": doc.data().Source};
						
						if((doc.data().hasOwnProperty('Tags') && doc.data().Tags && doc.data().Tags.length)) {
							ProspectData = {...ProspectData, "Tags": doc.data().Tags};
						}
						if((doc.data().hasOwnProperty('Number') && doc.data().Number !== '')) {
							ProspectData = {...ProspectData, "Number": doc.data().Number};
						}
						if((doc.data().hasOwnProperty('Publisher') && doc.data().Publisher !== '')) {
							ProspectData = {...ProspectData, "Publisher": doc.data().Publisher};
						}
						if((doc.data().hasOwnProperty('Questionnaire') && doc.data().Questionnaire !== '')) {
							ProspectData = {...ProspectData, "Questionnaire": doc.data().Questionnaire};
						}
						if((doc.data().hasOwnProperty('Device') && doc.data().Device !== '')) {
							ProspectData = {...ProspectData, "Device": doc.data().Device};
						}
						if((doc.data().hasOwnProperty('Interviewed') && doc.data().Interviewed !== '')) {
							ProspectData = {...ProspectData, "Interviewed": doc.data().Interviewed};
						}
						if((doc.data().hasOwnProperty('InterviewShow') && doc.data().InterviewShow !== '')) {
							ProspectData = {...ProspectData, "InterviewShow": doc.data().InterviewShow};
						}
						if((doc.data().hasOwnProperty('Hired') && doc.data().Hired !== '')) {
							ProspectData = {...ProspectData, "Hired": doc.data().Hired};
						}
						if(doc.data().hasOwnProperty('CciMap')) {
							ProspectData = {...ProspectData, "CciMap": doc.data().CciMap};
						}
						if(doc.data().hasOwnProperty('Stages') && doc.data().Stages && doc.data().Stages.length) {
							ProspectData = {...ProspectData, "Stages": doc.data().Stages};
						}
						if(doc.data().hasOwnProperty('LTC')) {
							ProspectData = {...ProspectData, "LTC": doc.data().LTC};
						}
						if((doc.data().hasOwnProperty('Status') && (doc.data().Status === 'New' || doc.data().Status === 'Contacted' || doc.data().Status === 'Development Done' || doc.data().Status === 'Post-Interview Nurture' || doc.data().Status === 'Pre-Interview Nurture' || doc.data().Status === 'Offer' || doc.data().Status === 'Hired' || doc.data().Status === 'Lost to competitor') )) {
							ProspectData = {...ProspectData, "Status": doc.data().Status};
						}
						if((doc.data().hasOwnProperty('InterviewScore') && doc.data().InterviewScore !== '' && doc.data().InterviewScore !== null)) {
							ProspectData = {...ProspectData, "InterviewScore": doc.data().InterviewScore};
						}
						if (Object.keys(ProspectData).length) {
							MergeProspectData.push(ProspectData);
						}
					})
					element.prospData = MergeProspectData;// ADD PROSPECT ARRAY IN USER KEY (prospData)
					return element;
				}))

				//eslint-disable-next-line
				console.log("finalArray1 650", finalArray1[0]);*/

				this.getCurrentCompanyDetail = aa1[0];

				this.isShowProspectsData = true;
				this.preparePDFReport();
				await this.calculatePDFAdCostNationalAverage();
				
				/*let passData = {
					selectedCompany: [this.companyField]
				};
				//eslint-disable-next-line
				console.log("fetchPDFDataSelectedUser API is processing...", passData);
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/fetchSelectedUser", passData)
				// await axios.post("http://localhost:5000/tatext-thirdpool/us-central1/tatext/fetchSelectedUser", passData)
				.then(response => {
					//eslint-disable-next-line
					console.log("fetchPDFDataSelectedUser API response", response.data[0]);
					this.getCurrentCompanyDetail = response.data[0];

					//eslint-disable-next-line
					console.log("this.getCurrentCompanyDetail 665", this.getCurrentCompanyDetail);

					this.isShowProspectsData = true;
					this.preparePDFReport();
					this.calculatePDFAdCostNationalAverage();
				}).catch(err => alert(`Something wrong for fetching PDF data: ${err}`));
				*/
			},
			// FOR TILES REPORT
			fetchSelectedUser() {
				//eslint-disable-next-line
				console.log("Selected user API is processing...");
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/fetchSelectedUser", {
					selectedCompany: this.array4
				})
				/*axios.post("http://localhost:5000/tatext-thirdpool/us-central1/tatext/fetchSelectedUser", {
					selectedCompany: this.array4
				})*/
				.then(response => {
					//eslint-disable-next-line
					console.log("fetchSelectedUser response", response.data);
					this.companySelectOrNot = false;
					this.filterClicked = false;
					this.allusersData = response.data;
					this.filterallusersData = response.data;
					//eslint-disable-next-line
					console.log("allusersData", this.allusersData);
					Object.assign(this.allusersObjectData,this.allusersData); // STORE ORIGINAL DATA
					this.startDateendDate();
					this.masterReport();
				}).catch(err => alert(`Something wrong for fetching data: ${err}`));
			},
			// LIST OF COMPANY 
			companyUserDropdownList() {
				//eslint-disable-next-line
				console.log("company list API is processing...");
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/companyUsers")
				// axios.post("http://localhost:5000/tatext-thirdpool/us-central1/tatext/companyUsers")
				.then(response => {
					this.pageLoader = false;
					//eslint-disable-next-line
					console.log("company list API Response::", response.data);
					this.companyUserList = response.data;
					// RESET THE FILTER, ONCE THE API RESPONSE IS SUCCESS (COMPANY FILTER PURPOSE) 
					this.checkboxDataWithFilterDropdown = [];
					this.FilterByOfficesManagers();
					this.companyUserList.forEach(cc=>{
						this.cUid.push(cc.uid);
					});
					this.updateTeamIDTempScript();
				}).catch(err => alert(`Something wrong for fetching company list data: ${err}`));
			},
			// CHECK PDF FILE DOWNLODING
			downloadPDF() {
				this.$refs.html2Pdf.generatePdf()
			},
			// SET TWO DIGIT NUMBER
			leftPad(number, targetLength) {
				var output = number + '';
				while (output.length < targetLength) {
					output = '0' + output;
				}
				return output;
			},
			// RECUITING PIPELINE
            RecruitingPipeline(element) {
				if (element.Stages && element.Stages.length > 0) {
                    element.Stages.filter(element1 => {
                        // MONTHLY REPORT
						if(element1.Date && (element1.Date >= this.convertselectedMonthFirstDay && element1.Date <= this.convertselectedMonthLastDay)) { 
							if(element1.Stage == "Pre-Interview Nurture") {
                                this.PDFStatusPreInt = this.PDFStatusPreInt + 1;
                            }
                            if(element1.Stage == "Post-Interview Nurture") {
                                this.PDFStatusPostInt = this.PDFStatusPostInt + 1;
                            }
                            if(element1.Stage == "Offer") {
                                this.PDFStatusOff = this.PDFStatusOff + 1;
                            }
                        }
						// YEARLY REPORT
						if(element1.Date && (element1.Date >= this.convertsetFirstJan && element1.Date <= this.convertselectedMonthLastDay)) {
							if(element1.Stage == "Pre-Interview Nurture") {
                                this.yPDFStatusPreInt = this.yPDFStatusPreInt + 1;
                            }
                            if(element1.Stage == "Post-Interview Nurture") {
                                this.yPDFStatusPostInt = this.yPDFStatusPostInt + 1;
                            }
                            if(element1.Stage == "Offer") {
                                this.yPDFStatusOff = this.yPDFStatusOff + 1;
                            }
						}

                    });
                }
            },
			// CALCULATE INBOUND OUTBOUND VALUE
            async CalculateInboundOutbound(elementconvosid) {
				if (this.convoCollectionData.length) {
                    let mesRef = await db.collection(`Conversations/${elementconvosid}/Messages`).get();
                        let messageList = mesRef.docs.map((doc) => {
                        let data = {...doc.data() };
                        return data;
                    })
					if (messageList.length) {
                        for (let m of messageList) {
                            if (m.Inbound) {
								if(this.CheckUniqueInboundMessage == 0){
                                    this.totalInboundMessageCount = this.totalInboundMessageCount + 1;
                                    this.CheckUniqueInboundMessage = 1;
                                }
								// this.sumOfInbound = this.sumOfInbound + 1;
                            }else {
                                if(this.CheckUniqueOutBoundMessage == 0){
                                    this.totalOutBoundMessageCount = this.totalOutBoundMessageCount + 1;
                                    this.CheckUniqueOutBoundMessage = 1;
                                }
								// this.sumOfOutbound = this.sumOfOutbound + 1;
                            }
						}
                        this.CheckUniqueInboundMessage = 0;
                        this.CheckUniqueOutBoundMessage = 0;
                    }
                    this.isShowConvoAnalytics = true;
                } else {
                    this.isShowConvoAnalytics = true;
                }

				/*var respoArray = {
					"totalInboundMessageCount": this.totalInboundMessageCount,
					"totalOutBoundMessageCount": this.totalOutBoundMessageCount
					// "sumOfInbound": this.sumOfInbound,
					// "sumOfOutbound": this.sumOfOutbound
				};

				//eslint-disable-next-line
				console.log("respoArray", respoArray);
				*/
				

				

			},
			async CalculateInboundOutbound2(elementconvosid) {
				if (this.convoCollectionData.length) {
					let mesRef = await db.collection(`Conversations/${elementconvosid}/Messages`).where("Date", ">=", this.convertselectedMonthFirstDay).where("Date", "<=", this.convertselectedMonthLastDay).get();
                        let messageList = mesRef.docs.map((doc) => {
                        let data = {...doc.data() };
                        return data;
                    })
					if (messageList.length) {
                        for (let m of messageList) {
                            if (m.Inbound) {
                                this.sumOfInbound = this.sumOfInbound + 1;
                            }else {
                                this.sumOfOutbound = this.sumOfOutbound + 1;
                            }
                        }
                    }
                    this.isShowConvoAnalytics = true;
                } else {
                    this.isShowConvoAnalytics = true;
                }

				/*var respoArray = {
					// "totalInboundMessageCount": this.totalInboundMessageCount,
					// "totalOutBoundMessageCount": this.totalOutBoundMessageCount
					"sumOfInbound": this.sumOfInbound,
					"sumOfOutbound": this.sumOfOutbound
				};

				//eslint-disable-next-line
				console.log("respoArray2", respoArray);
				*/

				

			},
			// PDF CALCULATION
			preparePDFReport() {

				if(this.getCurrentCompanyDetail.prospData) {

					let selectMonthFirstDay = new Date(this.year, this.month, 1);
					this.convertselectedMonthFirstDay = moment(selectMonthFirstDay).valueOf();
					let selectMonthLastDay = new Date(this.year, this.month + 1, 0);
					this.convertselectedMonthLastDay = moment(selectMonthLastDay).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).valueOf();
					let setFirstJan = new Date(`01 Jan ${this.year}`);
					this.convertsetFirstJan = moment(setFirstJan).valueOf();

					this.getCurrentCompanyDetail.prospData.forEach(element=>{
						// MONTHLY REPORT
						if(element.DateCreated && (element.DateCreated >= this.convertselectedMonthFirstDay && element.DateCreated <= this.convertselectedMonthLastDay)) {
							// THIRDPOOL AD
							if(element.Source) {
								if(element.Source == "ThirdPool Ad") {
									this.PDFThirdPoolProspectsCount  = this.PDFThirdPoolProspectsCount + 1;
								}
							}
							// NOT THIRDPOOL AD
							if(!element.hasOwnProperty('Source') || element.Source != "ThirdPool Ad") {
								this.PDFOrganicProspectsCount = this.PDFOrganicProspectsCount + 1;
							}
							// RECRUITING PROSPECTS
							if(!element.hasOwnProperty('Source') || element.Source != "") {
								this.PDFSourceCount = this.PDFSourceCount + 1;
							}
							// ADDED TO PIPELINE (TOTAL NUMBER OF PROSPECTS)
							this.mPDFAddedToPipeline = this.mPDFAddedToPipeline + 1;
						
							if(element.hasOwnProperty('Tags') && element.Tags.length && element.Tags.includes("Exploring")) {
								this.PDFTag1 = this.PDFTag1 + 1;
							}
							if(element.hasOwnProperty('Tags') && element.Tags.length && element.Tags.includes("In-Process")) {
								this.PDFTag2 = this.PDFTag2 + 1;
							}
							if(element.hasOwnProperty('Tags') && element.Tags.length && element.Tags.includes("Licensed")) {
								this.PDFTag3 = this.PDFTag3 + 1;
							}

						}

						this.RecruitingPipeline(element);

						// PIPE IMAGE: PRE-INTERVIEW NURTURE
						if(element.hasOwnProperty('Status') && element.Status && element.Status == "Pre-Interview Nurture") {
							this.PipePDFStatusPreInt = this.PipePDFStatusPreInt + 1;
						}
						// PIPE IMAGE: POST-INTERVIEW NURTURE
						if(element.hasOwnProperty('Status') && element.Status && element.Status == "Post-Interview Nurture") {
							this.PipePDFStatusPostInt = this.PipePDFStatusPostInt + 1;
						}
						// PIPE IMAGE: OFFER
						if(element.hasOwnProperty('Status') && element.Status && element.Status == "Offer") {
							this.PipePDFStatusOff = this.PipePDFStatusOff + 1;
						}

						// PROJECTED HIRES
						if(element.Hired != "" && typeof element.Hired !== 'undefined') {
							var CurrentDateOne = new Date(); // CURRENT DATE
							var CurrentDateTwo = CurrentDateOne.getFullYear(); // CURRENT YEAR
							var CurrentDateThree = new Date('01 Jan '+CurrentDateTwo+''); // 1st JAN CURRENT YEAR 
							if(element.Hired && (element.Hired >= CurrentDateThree && element.Hired <= CurrentDateOne)) {
								this.Phase1ProjectedHires = this.Phase1ProjectedHires  + 1;
							}
							this.dateDifferenceJanToCurrentYear(CurrentDateOne, CurrentDateThree);
						}
						// MONTHLY: INTERVIEWES COMPLETED
						if(element.Interviewed && (element.Interviewed >= this.convertselectedMonthFirstDay && element.Interviewed <= this.convertselectedMonthLastDay)) {
							this.mPDFInterviewesCompleted = this.mPDFInterviewesCompleted + 1;
						}
						// MONTHLY: INTERVIEWE NO-SHOW
						if(element.InterviewShow && (element.InterviewShow >= this.convertselectedMonthFirstDay && element.InterviewShow <= this.convertselectedMonthLastDay)) {
							this.mPDFIntervieweShowCompleted = this.mPDFIntervieweShowCompleted + 1;
						}
						// MONTHLY: LTC
						if(element.LTC && (element.LTC >= this.convertselectedMonthFirstDay && element.LTC <= this.convertselectedMonthLastDay)) {
							this.mPDFLTCCount = this.mPDFLTCCount + 1;
						}
						// MONTHLY: HIRED
						if(element.Hired && (element.Hired >= this.convertselectedMonthFirstDay && element.Hired <= this.convertselectedMonthLastDay)) {
							this.mPDFHiredCount = this.mPDFHiredCount + 1;
						}
						
						if(this.PDFTag1) { this.pTag1 = Math.round(((this.PDFTag1 / this.mPDFAddedToPipeline)*100)); }
						if(this.PDFTag2) { this.pTag2 = Math.round(((this.PDFTag2 / this.mPDFAddedToPipeline)*100)); }
						if(this.PDFTag3) { this.pTag3 = Math.round(((this.PDFTag3 / this.mPDFAddedToPipeline)*100)); }
						
						// YEARLY REPORT
						if(element.DateCreated && (element.DateCreated >= this.convertsetFirstJan && element.DateCreated <= this.convertselectedMonthLastDay)) {
							// ADDED TO PIPELINE
							this.yPDFAddedToPipeline = this.yPDFAddedToPipeline + 1;
						}
						// YEARLY: INTERVIEWES COMPLETED
						if(element.Interviewed && (element.Interviewed >= this.convertsetFirstJan && element.Interviewed <= this.convertselectedMonthLastDay)) {
							this.yPDFInterviewesCompleted = this.yPDFInterviewesCompleted + 1;
						}
						// YEARLY: INTERVIEWE NO SHOW
						if(element.InterviewShow && (element.InterviewShow >= this.convertsetFirstJan && element.InterviewShow <= this.convertselectedMonthLastDay)) {
							this.yPDFIntervieweShowCompleted = this.yPDFIntervieweShowCompleted + 1;
						}
						// YEARLY: LTC
						if(element.LTC && (element.LTC >= this.convertsetFirstJan && element.LTC <= this.convertselectedMonthLastDay)) {
							this.yPDFLTCCount = this.yPDFLTCCount + 1;
						}
						// YEARLY: HIRED
						if(element.Hired && (element.Hired >= this.convertsetFirstJan && element.Hired <= this.convertselectedMonthLastDay)) {
							this.yPDFHiredCount = this.yPDFHiredCount + 1;
						}
					})
					// AD COST YOUR COMPANY
					if(this.mPDFAddedToPipeline) {
						if(this.getCurrentCompanyDetail.hasOwnProperty('MonthlyAdCost') && this.getCurrentCompanyDetail.MonthlyAdCost) {
							var bindMYKey = this.getMonthName(this.month)+''+this.year; // February2022
							if(this.getCurrentCompanyDetail.MonthlyAdCost.hasOwnProperty([bindMYKey])) {
								var getMWsieValue = this.getCurrentCompanyDetail.MonthlyAdCost[bindMYKey]; // 600
								if(getMWsieValue) {
									var AdCostValue1 = getMWsieValue.replace(',',''); // GET DYNAMIC VALUE ACCORDING TO MONTH YEAR FILTER
									this.PDFAdCostYourCompany = (AdCostValue1 / this.mPDFAddedToPipeline).toFixed(2); 
								}
							}
						}
					}
					// SOURCING COST PER HIRE (YOUR COMPANY)
					if(this.projectedHire || this.projectedHireField) {
						if(this.getCurrentCompanyDetail.hasOwnProperty('MonthlyTotalCost') && this.getCurrentCompanyDetail.MonthlyTotalCost) {
							var bindMYKey1 = this.year+'ProjectedCost'; // 2022ProjectedCost
							if(this.getCurrentCompanyDetail.MonthlyTotalCost.hasOwnProperty([bindMYKey1])) {
								var getTotalValue1 = this.getCurrentCompanyDetail.MonthlyTotalCost[bindMYKey1]; // 600
								if(getTotalValue1) {
									var AdCostValue2 = getTotalValue1.replace(',',''); // GET DYNAMIC VALUE ACCORDING TO MONTH YEAR FILTER
									if(this.projectedHireField) {
										this.PDFSourcingCostYC = (AdCostValue2 / this.projectedHireField).toFixed(2); 
									} else {
										this.PDFSourcingCostYC = (AdCostValue2 / this.projectedHire).toFixed(2); 
									}
								}
							}
						}
					}

					// INTERVIEW RATE
					if(this.PDFSourceCount) {
						this.PDFInterviewRateYour = Math.round(((this.mPDFInterviewesCompleted / this.PDFSourceCount)*100));
					} 
					// HIRE RATE
					if(this.mPDFInterviewesCompleted) {
						this.PDFHiredRateYour = Math.round(((this.mPDFHiredCount / this.mPDFInterviewesCompleted)*100));
					} 
					// LTC RATE
					if(this.mPDFInterviewesCompleted) {
						this.PDFLTCRateYour = Math.round(((this.mPDFLTCCount / this.mPDFInterviewesCompleted)*100));
					} 
					// MONTHLY: INTERVIEW NO SHOW RATE
					if(this.mPDFIntervieweShowCompleted) {
						this.PDFInterviewNoShowRate = Math.round(((this.mPDFIntervieweShowCompleted / (this.mPDFInterviewesCompleted + this.mPDFIntervieweShowCompleted))*100)); 
					}
					// YEARLY: INTERVIEW NO SHOW RATE
					// if(this.yPDFIntervieweShowCompleted) {
					// 	this.yPDFInterviewNoShowRate = Math.round(((this.yPDFIntervieweShowCompleted / (this.yPDFInterviewesCompleted + this.yPDFIntervieweShowCompleted))*100)); 
					// }

					this.showProspectsData = true;
				
				} else {
					this.showProspectsData = true;
				}

			},
			// ON CHANGE COMPANY NAME (POPUP)
			onChangePopupCompany() {
				var tempA = [];
				tempA = this.companyUserList.find(nm=> nm.uid == this.companyField);
				if(tempA) {
					this.nickName = tempA.company;
				} else {
					this.nickName = '';
					tempA = [];
				}
			},
			// FILTER LOGIC
			filterByDataManage() {
				if(this.allusersObjectData && this.allusersObjectData.length) {
					if(this.array1.length || this.array2.length || this.array3.length) {
						let known = new Set();
						let setArrayFilter = [];
						this.allusersObjectData.forEach(a=>{
							
							let udata = { id: a.id, uid:a.uid, company: a.company, first: a.first, last: a.last, prospData:{}};
							var tmparrayA1MergeData = [];
							var tmparrayA1 = [];
							var tmparrayFinal = [];
							var tmparray2MergeData = [];
							var tmparray2 = [];
							var tmparray3MergeData = [];
							var tmparray3 = [];
							
							// SOURCE
							this.array1.forEach(e1=>{
								var s1;
								if(e1 == '1') {
									s1 = a.prospData.filter(f1=> (f1.hasOwnProperty('Source') && f1.Source == 'ThirdPool Ad'));
								} else if(e1 == '2') {
									s1 = a.prospData.filter(g1=> (!g1.hasOwnProperty('Source') || g1.Source != 'ThirdPool Ad'));
								}
								tmparrayA1.push(s1);
								tmparrayA1MergeData = [].concat.apply([], tmparrayA1);
							});
							// PUBLISHER
							this.array2.forEach(a1=>{
								var p = a.prospData.filter(b1=> b1.Publisher == a1);
								tmparray2.push(p);
								tmparray2MergeData = [].concat.apply([], tmparray2);
							});
							// DEVICE
							this.array3.forEach(c1=>{
								var d = a.prospData.filter(d1=> d1.Device == c1);
								tmparray3.push(d);
								tmparray3MergeData = [].concat.apply([], tmparray3);
							});
							if(tmparrayA1MergeData.length || tmparray2MergeData.length || tmparray3MergeData.length) {
								var k3 = [...tmparrayA1MergeData, ...tmparray2MergeData, ...tmparray3MergeData];
								tmparrayFinal = k3.filter(item => !known.has(item.Pid) && known.add(item.Pid));
							}
							
							udata.prospData = tmparrayFinal
							setArrayFilter.push(udata);
						})
						//eslint-disable-next-line
						console.log("setArrayFilter", setArrayFilter);
						if(setArrayFilter && setArrayFilter.length) {
							this.filterallusersData = setArrayFilter;
						}
					} else {
						this.filterallusersData = this.allusersObjectData;
					}
				} else {
					this.filterallusersData = [];
				}
			},
			// GENERATE PDF REPORT AFTER FILL FORM
			async GenerateReportPDFForm() {
				if(this.companyField && this.month !== null && this.year && this.nickName) {
					this.PDFResetInitVal();
					this.makePDFFileName = `Master-Report-${this.nickName.replace(/\s+/g, '-')}-${this.getMonthName(this.month)}-${this.year}`;
					this.$bvModal.hide('CreateStartReport');
					this.pageLoader = true;
					await this.fetchPDFDataSelectedUser();
					await this.basedOnUserCountConvos();
					
					var respoArray1 = {
						"totalInboundMessageCount": this.totalInboundMessageCount,
						"totalOutBoundMessageCount": this.totalOutBoundMessageCount,
						"sumOfInbound": this.sumOfInbound,
						"sumOfOutbound": this.sumOfOutbound
					};

					//eslint-disable-next-line
					console.log("respoArray1", respoArray1);
					//eslint-disable-next-line
					console.log("this.getCurrentCompanyDetail.prospData.length", this.getCurrentCompanyDetail.prospData.length);
					//eslint-disable-next-line
					console.log("this.isShowProspectsData", this.isShowProspectsData);
					//eslint-disable-next-line
					console.log("this.isShowConvoAnalytics", this.isShowConvoAnalytics);

					// WRITE CODE: DOWNLOAD PDF FILE
					// if(this.getCurrentCompanyDetail.prospData.length && this.isShowProspectsData && this.isShowConvoAnalytics) {
					if(this.getCurrentCompanyDetail.prospData.length) {
						setTimeout(() => {
							this.$refs.html2Pdf.generatePdf();
							this.pageLoader = false;
						}, 3000);
					}
				} else {
					alert("Please Select Company, Nick Name, Month and Year");
				}
			},
			// PROSPECT STAGES CHART
			prospectStagesChart(element1) {
				if(element1.hasOwnProperty('Status') && element1.Status == "New") {
					this.countNewStages = this.countNewStages + 1;
				}
				if(element1.hasOwnProperty('Status') && element1.Status == "Contacted") {
					this.countContactedStages = this.countContactedStages + 1;
				}
				if(element1.hasOwnProperty('Status') && element1.Status == "Development Done") {
					this.countDevelopmentDoneStages = this.countDevelopmentDoneStages + 1;
				}
				if(element1.hasOwnProperty('Status') && element1.Status == "Post-Interview Nurture") {
					this.countPostInterviewStages = this.countPostInterviewStages + 1;
				}
				if(element1.hasOwnProperty('Status') && element1.Status == "Pre-Interview Nurture") {
					this.countPreInterviewStages = this.countPreInterviewStages + 1;
				}
				if(element1.hasOwnProperty('Status') && element1.Status == "Offer") {
					this.countOfferStages = this.countOfferStages + 1;
				}
				if(element1.hasOwnProperty('Status') && element1.Status == "Hired") {
					this.countHiredStages = this.countHiredStages + 1;
				}
				if(element1.hasOwnProperty('Status') && element1.Status == "Lost to competitor") {
					this.countLostStages = this.countLostStages + 1;
				}
			},
			// PROJECTED HIRES: FIND THE DATE DIFF VALUE
            dateDifferenceJanToCurrentYear(date2, date1) {
                const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
                const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
                var ProjectedHiresDayCount = Math.floor((utc2 - utc1) / _MS_PER_DAY); // DAY COUNT (FROM START TO END)
                var ProjectedHiresValue = this.Phase1ProjectedHires / ProjectedHiresDayCount * 365;
                var FinalValueProjectedHires = Math.round(ProjectedHiresValue); //ProjectedHiresValue.toFixed(2);
				this.projectedHire = FinalValueProjectedHires;
            },
			// MASTER REPORT
			masterReport() {
				this.ResetInitVal();
				this.filterByDataManage();
				if(this.filterallusersData) {
					this.filterallusersData.forEach(element => {
					element.prospData.forEach(element1 => {
						if(element1.DateCreated && (element1.DateCreated >= this.startDate && element1.DateCreated <= this.endDate)) {
							if(element1.Source) {
								// THIRDPOOL AD
                                if(element1.Source == "ThirdPool Ad") {
                                    this.ThirdPoolProspectsCount  = this.ThirdPoolProspectsCount + 1;
                                }
							}
							// NOT THIRDPOOL AD
							if(!element1.hasOwnProperty('Source') || element1.Source != "ThirdPool Ad") {
								this.OrganicProspectsCount = this.OrganicProspectsCount + 1;
							}
							// COMPLETED QUESTIONNAIRE
							if(element1.hasOwnProperty('Questionnaire') && element1.Questionnaire == "completed") {
								this.QuestionnaireProspectsCount = this.QuestionnaireProspectsCount + 1;
							}
							// COMPLETED CCI
                            if(element1.CciMap != null && element1.CciMap !== 'undefined') {
                                if(element1.CciMap.DateSubmitted != 0 && element1.CciMap.DateSubmitted != '') {
                                    this.CCICount = this.CCICount + 1;
								}
                            }
							// PROSPECT STAGES
							this.prospectStagesChart(element1);
						}
						// INTERVIEWED
                        if(element1.Interviewed && (element1.Interviewed >= this.startDate && element1.Interviewed <= this.endDate)) {
                            this.InterviewsCount = this.InterviewsCount + 1;
							if(element1.InterviewScore) {
                                this.SumInterviewScore = this.SumInterviewScore + element1.InterviewScore;
                                this.CountInterviewScore = this.CountInterviewScore + 1;
                            }
                        }
						// HIRED
                        if(element1.Hired && (element1.Hired >= this.startDate && element1.Hired <= this.endDate)) {
                            this.HiredCount = this.HiredCount + 1;
                        }
					});
					// AVERAGE INTERVIEW RATING
                    let AverageInterviewRating = this.SumInterviewScore / this.CountInterviewScore;
                    if(AverageInterviewRating) {
                        this.FinalInterviewAverage = AverageInterviewRating.toFixed(2);
                    }
					this.prospectStageSeries = [{
						data: [this.countNewStages, this.countContactedStages, this.countDevelopmentDoneStages, this.countPostInterviewStages, this.countPreInterviewStages, this.countOfferStages, this.countHiredStages, this.countLostStages]
					}];
				});
					this.filterClicked = false;
				} else {
					this.ResetInitVal();
					this.filterClicked = false;
				}	
			},
			startDateendDate() {
                this.startDate = moment(this.form.s_date).valueOf();
                this.endDate = moment(this.form.e_date).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).valueOf();
			},
			async commonQuery(ele) {
				var userQuery = await db.collection(`Users`).where("Uid", "==", ele).get();
				let userQueryData = userQuery.docs.map((doc) => {
					let data = { id: doc.id, uid:doc.data().Uid, first: doc.data().First, last: doc.data().Last, company: doc.data().Company, version: doc.data().Version, benchmark: doc.data().Benchmark, MonthlyAdCost: doc.data().MonthlyAdCost, MonthlyTotalCost: doc.data().MonthlyTotalCost, prospData:{}};
					return data;
				})
				//eslint-disable-next-line
				console.log("userQueryData", userQueryData);
				var finalArray = await Promise.all(userQueryData.map(async(element) => {
					var proRef1Test = await db.collection(`Users/${element.id}/Prospects`).get();
					var MergeProspectData = [];
					proRef1Test.docs.map((doc) => {
						
						var ProspectData = {};

						ProspectData = {...ProspectData, "Pid": doc.id}; 
						ProspectData = {...ProspectData, "DateCreated": doc.data().DateCreated};
						ProspectData = {...ProspectData, "Source": doc.data().Source};
						
						if((doc.data().hasOwnProperty('Tags') && doc.data().Tags && doc.data().Tags.length)) {
							ProspectData = {...ProspectData, "Tags": doc.data().Tags};
						}
						if((doc.data().hasOwnProperty('Number') && doc.data().Number !== '')) {
							ProspectData = {...ProspectData, "Number": doc.data().Number};
						}
						if((doc.data().hasOwnProperty('Publisher') && doc.data().Publisher !== '')) {
							ProspectData = {...ProspectData, "Publisher": doc.data().Publisher};
						}
						if((doc.data().hasOwnProperty('Questionnaire') && doc.data().Questionnaire !== '')) {
							ProspectData = {...ProspectData, "Questionnaire": doc.data().Questionnaire};
						}
						if((doc.data().hasOwnProperty('Device') && doc.data().Device !== '')) {
							ProspectData = {...ProspectData, "Device": doc.data().Device};
						}
						if((doc.data().hasOwnProperty('Interviewed') && doc.data().Interviewed !== '')) {
							ProspectData = {...ProspectData, "Interviewed": doc.data().Interviewed};
						}
						if((doc.data().hasOwnProperty('InterviewShow') && doc.data().InterviewShow !== '')) {
							ProspectData = {...ProspectData, "InterviewShow": doc.data().InterviewShow};
						}
						if((doc.data().hasOwnProperty('Hired') && doc.data().Hired !== '')) {
							ProspectData = {...ProspectData, "Hired": doc.data().Hired};
						}
						if(doc.data().hasOwnProperty('CciMap')) {
							ProspectData = {...ProspectData, "CciMap": doc.data().CciMap};
						}
						if(doc.data().hasOwnProperty('Stages') && doc.data().Stages && doc.data().Stages.length) {
							ProspectData = {...ProspectData, "Stages": doc.data().Stages};
						}
						if(doc.data().hasOwnProperty('LTC')) {
							ProspectData = {...ProspectData, "LTC": doc.data().LTC};
						}
						if((doc.data().hasOwnProperty('Status') && (doc.data().Status === 'New' || doc.data().Status === 'Contacted' || doc.data().Status === 'Development Done' || doc.data().Status === 'Post-Interview Nurture' || doc.data().Status === 'Pre-Interview Nurture' || doc.data().Status === 'Offer' || doc.data().Status === 'Hired' || doc.data().Status === 'Lost to competitor') )) {
							ProspectData = {...ProspectData, "Status": doc.data().Status};
						}
						if((doc.data().hasOwnProperty('InterviewScore') && doc.data().InterviewScore !== '' && doc.data().InterviewScore !== null)) {
							ProspectData = {...ProspectData, "InterviewScore": doc.data().InterviewScore};
						}
						if (Object.keys(ProspectData).length) {
							MergeProspectData.push(ProspectData);
						}
					})
					element.prospData = MergeProspectData;// ADD PROSPECT ARRAY IN USER KEY (prospData)
					return element;
				}))
				return finalArray;
			},
			async applyFilterTemp() {
				
				this.form.s_date = this.form.date_s;
				this.form.e_date = this.form.date_e;
				this.filterClicked = true;
				this.allusersData = [];
				this.filterallusersData = [];
				this.allusersObjectData = [];
				this.startDateendDate();
				
				if(this.array4 && this.array4.length) {
					
					//eslint-disable-next-line
					console.log("this.array4", this.array4);

					for(let a = 0; a < this.array4.length; a++) {

						var aa1 = await this.commonQuery(this.array4[a]);
						
						/*var userQuery = await db.collection(`Users`).where("Uid", "==", this.array4[a]).get();
						let userQueryData = userQuery.docs.map((doc) => {
							let data = { id: doc.id, uid:doc.data().Uid, first: doc.data().First, last: doc.data().Last, company: doc.data().Company, version: doc.data().Version, benchmark: doc.data().Benchmark, MonthlyAdCost: doc.data().MonthlyAdCost, MonthlyTotalCost: doc.data().MonthlyTotalCost, prospData:{}};
							return data;
						})
					
						//eslint-disable-next-line
						console.log("userQueryData", userQueryData);

						var finalArray = await Promise.all(userQueryData.map(async(element) => {
							var proRef1Test = await db.collection(`Users/${element.id}/Prospects`).get();
							var MergeProspectData = [];
							proRef1Test.docs.map((doc) => {
								
								var ProspectData = {};

								ProspectData = {...ProspectData, "Pid": doc.id}; 
								ProspectData = {...ProspectData, "DateCreated": doc.data().DateCreated};
								ProspectData = {...ProspectData, "Source": doc.data().Source};
								
								if((doc.data().hasOwnProperty('Tags') && doc.data().Tags && doc.data().Tags.length)) {
									ProspectData = {...ProspectData, "Tags": doc.data().Tags};
								}
								if((doc.data().hasOwnProperty('Number') && doc.data().Number !== '')) {
									ProspectData = {...ProspectData, "Number": doc.data().Number};
								}
								if((doc.data().hasOwnProperty('Publisher') && doc.data().Publisher !== '')) {
									ProspectData = {...ProspectData, "Publisher": doc.data().Publisher};
								}
								if((doc.data().hasOwnProperty('Questionnaire') && doc.data().Questionnaire !== '')) {
									ProspectData = {...ProspectData, "Questionnaire": doc.data().Questionnaire};
								}
								if((doc.data().hasOwnProperty('Device') && doc.data().Device !== '')) {
									ProspectData = {...ProspectData, "Device": doc.data().Device};
								}
								if((doc.data().hasOwnProperty('Interviewed') && doc.data().Interviewed !== '')) {
									ProspectData = {...ProspectData, "Interviewed": doc.data().Interviewed};
								}
								if((doc.data().hasOwnProperty('InterviewShow') && doc.data().InterviewShow !== '')) {
									ProspectData = {...ProspectData, "InterviewShow": doc.data().InterviewShow};
								}
								if((doc.data().hasOwnProperty('Hired') && doc.data().Hired !== '')) {
									ProspectData = {...ProspectData, "Hired": doc.data().Hired};
								}
								if(doc.data().hasOwnProperty('CciMap')) {
									ProspectData = {...ProspectData, "CciMap": doc.data().CciMap};
								}
								if(doc.data().hasOwnProperty('Stages') && doc.data().Stages && doc.data().Stages.length) {
									ProspectData = {...ProspectData, "Stages": doc.data().Stages};
								}
								if(doc.data().hasOwnProperty('LTC')) {
									ProspectData = {...ProspectData, "LTC": doc.data().LTC};
								}
								if((doc.data().hasOwnProperty('Status') && (doc.data().Status === 'New' || doc.data().Status === 'Contacted' || doc.data().Status === 'Development Done' || doc.data().Status === 'Post-Interview Nurture' || doc.data().Status === 'Pre-Interview Nurture' || doc.data().Status === 'Offer' || doc.data().Status === 'Hired' || doc.data().Status === 'Lost to competitor') )) {
									ProspectData = {...ProspectData, "Status": doc.data().Status};
								}
								if((doc.data().hasOwnProperty('InterviewScore') && doc.data().InterviewScore !== '' && doc.data().InterviewScore !== null)) {
									ProspectData = {...ProspectData, "InterviewScore": doc.data().InterviewScore};
								}
								if (Object.keys(ProspectData).length) {
									MergeProspectData.push(ProspectData);
								}
							})
							element.prospData = MergeProspectData;// ADD PROSPECT ARRAY IN USER KEY (prospData)
							return element;
						}))*/

						this.allusersDataTemp = [...this.allusersDataTemp, ...aa1];
					}
					
					//eslint-disable-next-line
					console.log("this.allusersDataTemp:", this.allusersDataTemp);
					this.selectOnlyTen = 0;
					this.array4 = [];
				
				}

				this.filterClicked = false;
				this.allusersData = this.allusersDataTemp;
				this.filterallusersData = this.allusersDataTemp;
				//eslint-disable-next-line
				console.log("allusersData", this.allusersData);
				Object.assign(this.allusersObjectData,this.allusersData); // STORE ORIGINAL DATA
				this.startDateendDate();
				this.masterReport();

			},
			applyFilter() {
				if(this.array4 && this.array4.length) {
					this.form.s_date = this.form.date_s;
					this.form.e_date = this.form.date_e;
					if(this.companySelectOrNot) {
						this.filterClicked = true;
						this.allusersData = [];
						this.filterallusersData = [];
						this.allusersObjectData = [];
						this.fetchSelectedUser();
					} else {
						this.startDateendDate();
						this.masterReport();
					}
				} else {
					alert("Please Select Company");
				}
			},
			async calculatePDFAdCostNationalAverage() {
                var UserValSum = 0;
				var UserProsp = 0;
				var UserValSum2 = 0;
				var UserProsp2 = 0;
				
				// var benchmarkHired = 0;
				// var benchmarkInterviewed = 0;
				// var benchmarkInterviewShow = 0;
				// var benchmarkLTC = 0;
				// var finalbenchmarkInterviewShow = 0;
				
				var sumOfRecPros = 0;
				var sumOfInt = 0;
				var sumOfIntNShw = 0;
				var sumOfHir = 0;
				var sumOfLTC = 0;
				var sumOfHirYearly = 0;

				var AdCostNA = this.companyUserList.filter(pr => pr.benchmark == true);
				for (let i = 0; i < AdCostNA.length; i++) {
					var elm = AdCostNA[i];
					//eslint-disable-next-line
					//console.log("elm", elm);
					if(elm.benchmark) {
						// ADVERTISING COST PER HIRE
                        if(elm.hasOwnProperty('MonthlyAdCost')) {
                            var bindMYKey2 = this.getMonthName(this.month)+''+this.year; 
							if(elm.MonthlyAdCost.hasOwnProperty([bindMYKey2])) {
                                var getTotalValue2 = elm.MonthlyAdCost[bindMYKey2]; // 600
								if(getTotalValue2) {
                                    var getVal = getTotalValue2.replace(',','');
                                    if(UserValSum) {
                                        UserValSum = parseInt(UserValSum) + parseInt(getVal);
                                    } else {
                                        UserValSum = parseInt(getVal);
                                    }
                                }
                            }
                        }
						// PROJECTED SOURCING COST PER HIRE 
						if(elm.hasOwnProperty('MonthlyTotalCost')) {
							var bindMYKey3 = this.year+'TotalCost'; // 2022TotalCost
							if(elm.MonthlyTotalCost.hasOwnProperty([bindMYKey3])) {
                                var getTotalValue3 = elm.MonthlyTotalCost[bindMYKey3]; // 600
								if(getTotalValue3) {
                                    var getVal2 = getTotalValue3.replace(',','');
									if(UserValSum2) {
                                        UserValSum2 = parseInt(UserValSum2) + parseInt(getVal2);
                                    } else {
                                        UserValSum2 = parseInt(getVal2);
                                    }
                                }
                            }
                        }
						/*var proRef1 = await db.collection(`Users/${elm.id}/Prospects`).where("DateCreated", ">=", this.convertselectedMonthFirstDay).where("DateCreated", "<=", this.convertselectedMonthLastDay).get();
						UserProsp = UserProsp + proRef1.docs.length;
						var proRef2 = await db.collection(`Users/${elm.id}/Prospects`).where("DateCreated", ">=", this.convertselectedMonthFirstDay).where("DateCreated", "<=", this.convertselectedMonthLastDay).get();
						UserProsp2 = UserProsp2 + proRef2.docs.length;*/
						
						let colRef1 = await db.collection(`Users/${elm.id}/Prospects`).get();
						let prospectList1 = colRef1.docs.map((doc) => {
							let data = { id: doc.id, ...doc.data() };
							return data;
						})
						prospectList1.forEach(pp=>{
							if(pp.DateCreated >= this.convertselectedMonthFirstDay && pp.DateCreated <= this.convertselectedMonthLastDay) {
								UserProsp = UserProsp + 1;
							}
							if(pp.Hired && (pp.Hired >= this.convertselectedMonthFirstDay && pp.Hired <= this.convertselectedMonthLastDay)) {
								sumOfHir = sumOfHir + 1;
							}
							if(pp.Interviewed && (pp.Interviewed >= this.convertselectedMonthFirstDay && pp.Interviewed <= this.convertselectedMonthLastDay)) {
								sumOfInt = sumOfInt + 1;
							}
							if(pp.InterviewShow && (pp.InterviewShow >= this.convertselectedMonthFirstDay && pp.InterviewShow <= this.convertselectedMonthLastDay)) {
								sumOfIntNShw = sumOfIntNShw + 1;
							}
							if(pp.LTC && (pp.LTC >= this.convertselectedMonthFirstDay && pp.LTC <= this.convertselectedMonthLastDay)) {
								sumOfLTC = sumOfLTC + 1;
							}
							if(pp.Hired && (pp.Hired >= this.convertsetFirstJan && pp.Hired <= this.convertselectedMonthLastDay)) {
								sumOfHirYearly = sumOfHirYearly + 1;
							}
							if((!pp.hasOwnProperty('Source') || pp.Source != "") && pp.DateCreated && (pp.DateCreated >= this.convertselectedMonthFirstDay && pp.DateCreated <= this.convertselectedMonthLastDay)) {
								sumOfRecPros = sumOfRecPros + 1;
							}
						})

						/*
						var b = prospectList1.filter(el => el.Hired && (el.Hired >= this.convertselectedMonthFirstDay && el.Hired <= this.convertselectedMonthLastDay));
						sumOfHir = sumOfHir + b.length;
						// benchmarkHired = b.length;

						var c = prospectList1.filter(el2 => el2.Interviewed && (el2.Interviewed >= this.convertselectedMonthFirstDay && el2.Interviewed <= this.convertselectedMonthLastDay));
						sumOfInt = sumOfInt + c.length;
						// benchmarkInterviewed = c.length;

						var d = prospectList1.filter(el3 => el3.InterviewShow && (el3.InterviewShow >= this.convertselectedMonthFirstDay && el3.InterviewShow <= this.convertselectedMonthLastDay));
						sumOfIntNShw = sumOfIntNShw + d.length;
						// benchmarkInterviewShow = d.length;
						
						var e = prospectList1.filter(el4 => el4.LTC && (el4.LTC >= this.convertselectedMonthFirstDay && el4.LTC <= this.convertselectedMonthLastDay));
						sumOfLTC = sumOfLTC + e.length;
						// benchmarkLTC = e.length;

						var f = prospectList1.filter(el => el.Hired && (el.Hired >= this.convertsetFirstJan && el.Hired <= this.convertselectedMonthLastDay));
						sumOfHirYearly = sumOfHirYearly + f.length;
						
						var g = prospectList1.filter(el5 => (!el5.hasOwnProperty('Source') || el5.Source != "") && el5.DateCreated && (el5.DateCreated >= this.convertselectedMonthFirstDay && el5.DateCreated <= this.convertselectedMonthLastDay));
						sumOfRecPros = sumOfRecPros + g.length;*/

					}
				}

				// if(benchmarkInterviewShow) {
				// 	finalbenchmarkInterviewShow = Math.round(((benchmarkInterviewShow / (benchmarkInterviewed + benchmarkInterviewShow))*100)); 
				// }

				

				//eslint-disable-next-line
				console.log("UserValSum", UserValSum);
				//eslint-disable-next-line
				console.log("UserValSum2", UserValSum2);
				//eslint-disable-next-line
				console.log("UserProsp", UserProsp);
				//eslint-disable-next-line
				console.log("UserProsp2", UserProsp2);
				
				//eslint-disable-next-line
				// console.log("benchmarkHired", benchmarkHired);
				//eslint-disable-next-line
				// console.log("benchmarkInterviewed", benchmarkInterviewed);
				//eslint-disable-next-line
				// console.log("benchmarkInterviewShow", benchmarkInterviewShow);
				//eslint-disable-next-line
				// console.log("benchmarkLTC", benchmarkLTC);
				//eslint-disable-next-line
				// console.log("finalbenchmarkInterviewShow", finalbenchmarkInterviewShow);
				
				//eslint-disable-next-line
				console.log("sumOfRecPros", sumOfRecPros);
				//eslint-disable-next-line
				console.log("sumOfInt", sumOfInt);
				//eslint-disable-next-line
				console.log("sumOfIntNShw", sumOfIntNShw);
				//eslint-disable-next-line
				console.log("sumOfHir", sumOfHir);
				//eslint-disable-next-line
				console.log("sumOfLTC", sumOfLTC);

				//eslint-disable-next-line
				console.log("sumOfHirYearly", sumOfHirYearly);


				if(UserProsp) {
					this.AdCostNationalAverage = (UserValSum / UserProsp).toFixed(2);
				}
				
				// NEW LOGIC IN RPM: NATIONAL AVERAGE
				if(sumOfRecPros) {
					this.yPDFNAInterviewRate = Math.round(((sumOfInt / sumOfRecPros)*100)); // INTERVIEW RATE
				}
				if(sumOfInt) {
					this.yPDFNALTCRate = Math.round(((sumOfLTC / sumOfInt)*100)); // LTC RATE
					this.yPDFNAHiredRate = Math.round(((sumOfHir / sumOfInt)*100)); // HIRED RATE
				}
				if(sumOfIntNShw) {
					this.yPDFNAInterviewNoShowRate = Math.round(((sumOfIntNShw / (sumOfInt + sumOfIntNShw))*100)); // INTERVIEW NO SHOW
				}
				if(sumOfHirYearly) {
					this.SourcingCostNationalAverage = (UserValSum2 / sumOfHirYearly).toFixed(2);
				}
				
				//eslint-disable-next-line
				console.log("this.SourcingCostNationalAverage", this.SourcingCostNationalAverage);
			},
			// DYNAMIC POPUP
			bvToast(msg, title, variant) {
				this.$bvToast.toast(msg, {
					title: title,
					variant: variant,
					solid: true,
					autoHideDelay: 2000,
				});
			},
			// ONLOAD CHECK AUTH PERMISSION
			onLoadCheckAuthPermission() {
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/getAuthUser", {
				// axios.post("http://localhost:5000/tatext-thirdpool/us-central1/tatext/getAuthUser", {
					searchValue:auth.currentUser.email,
				})
				.then(response => {
					if(response.data == 0) { // 1.ACCESS 0.NOT ACCESS
						this.checkAuthLoader = false;
						this.checkAuth = true;
						this.strictWarning = true;
					}
				}).catch(err => alert(`Failure Auth Process On Load: ${err}`));
			},
			// LOGIN BUTTON PROCESS
			async masterLoginProcess() {
				this.checkLoginAccess();
				this.checkAuthLoader = true;
			},
			// CHECK LOGIN PERMISSION
			checkLoginAccess() {
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/getAuthUser", {
				// axios.post("http://localhost:5000/tatext-thirdpool/us-central1/tatext/getAuthUser", {
					searchValue:this.form.email,
				})
				.then(response => {
					//eslint-disable-next-line
					console.log("API Response", response);
					if(response.data == 1) { // 1.ACCESS 0.NOT ACCESS
						this.checkFirebaseAccess();
					} else {
						this.form.email = '';
						this.form.password = '';
						this.bvToast("Sorry, you don't have access. Please contact the administrator.", "Something Wrong", "danger");
						this.checkAuthLoader = false;
					}
				}).catch(err => alert(`Failure Auth Process: ${err}`));
			},
			// CHECK LOGIN CREDENTIAL WITH FIREBASE
			async checkFirebaseAccess() {
				await auth.signInWithEmailAndPassword(this.form.email, this.form.password)
				.then((userCredential) => {
					//eslint-disable-next-line
					console.log("userCredential", userCredential);
					this.bvToast("You are successfully logged in.", "Success", "info");
					this.checkAuth = false;
				})
				.catch((error) => {
						const errorCode = error.code;
						const errorMessage = error.message;
						//eslint-disable-next-line
						console.log("errorCode", errorCode);
						//eslint-disable-next-line
						console.log("errorMessage", errorMessage);
						this.bvToast("Incorrect email or password.", "Something Wrong", "danger");
						this.form.email = '';
						this.form.password = '';
					});
					this.checkAuthLoader = false;
			},
			// PDF INITIALIZE
			PDFResetInitVal() {
				this.PDFThirdPoolProspectsCount = 0;
				this.PDFOrganicProspectsCount = 0;
				this.PDFSourceCount = 0;
				
				this.mPDFInterviewesCompleted = 0;
				this.mPDFIntervieweShowCompleted = 0;
				this.yPDFIntervieweShowCompleted = 0;
				this.mPDFAddedToPipeline = 0;
				this.mPDFLTCCount = 0;
				this.mPDFHiredCount = 0;
				
				this.yPDFInterviewesCompleted = 0;
				this.yPDFAddedToPipeline = 0;
				this.yPDFLTCCount = 0;
				this.yPDFHiredCount = 0;

				this.PDFTag1 = 0; // Exploring
				this.PDFTag2 = 0; // In-Process
				this.PDFTag3 = 0; // Licensed
				this.pTag1 = 0;
				this.pTag2 = 0;
				this.pTag3 = 0;

				this.PDFAdCostYourCompany = 0;
				this.PDFStatusPreInt = 0;
				this.PDFStatusPostInt = 0;
				this.PDFStatusOff = 0;
				this.yPDFStatusPreInt = 0;
				this.yPDFStatusPostInt = 0;
				this.yPDFStatusOff = 0;
				this.PipePDFStatusPreInt = 0;
				this.PipePDFStatusPostInt = 0;
				this.PipePDFStatusOff = 0;

				this.projectedHire = 0;
				this.Phase1ProjectedHires = 0;

				this.PDFInterviewRateYour = 0;
				this.PDFHiredRateYour = 0;
				this.PDFLTCRateYour = 0;
				this.PDFInterviewNoShowRate = 0;
				// this.yPDFInterviewNoShowRate = 0;
				this.PDFSourcingCostYC = 0;
				this.makePDFFileName = '';

				this.CheckUniqueInboundMessage = 0;
				this.totalInboundMessageCount = 0;
				this.CheckUniqueOutBoundMessage = 0;
				this.totalOutBoundMessageCount = 0;
				this.isShowConvoAnalytics = false;
				this.isShowProspectsData = false;
				this.showProspectsData = false;
				this.sumOfInbound = 0;
				this.sumOfOutbound = 0;

				this.convertselectedMonthFirstDay = 0;
				this.convertselectedMonthLastDay = 0;
				this.convertsetFirstJan = 0;
				this.AdCostNationalAverage = 0;
				this.SourcingCostNationalAverage = 0;

				this.yPDFNAHiredRate = 0;
				this.yPDFNALTCRate = 0;
				this.yPDFNAInterviewRate = 0;
				this.yPDFNAInterviewNoShowRate = 0;

				this.convoCollectionData = [];
			},
			// INITIALIZE
			ResetInitVal() {
				this.ThirdPoolProspectsCount = 0;
				this.OrganicProspectsCount = 0;
				this.QuestionnaireProspectsCount = 0;
				this.InterviewsCount = 0;
				this.SumInterviewScore = 0;
				this.CountInterviewScore = 0;
				this.FinalInterviewAverage = 0;
				this.HiredCount = 0;
				this.countNewStages = 0;
				this.countContactedStages = 0;
				this.countDevelopmentDoneStages = 0;
				this.countPostInterviewStages = 0;
				this.countPreInterviewStages = 0;
				this.countOfferStages = 0;
				this.countHiredStages = 0;
				this.countLostStages = 0;
				this.prospectStageSeries = [{name: '', data: [0, 0, 0, 0, 0, 0, 0, 0]}];
				this.CCICount = 0;
			},
			// DISPLAY FILTER BY COUNT
            CheckboxLabel() {
                return 'Filter By ('+this.FilterByCount+')';
            },
			// FILTER: SOURCE
            SourceDropdownFilter() {
                let src = [
                    { name: 'ThirdPool Ad', id: 1, stype:'s' },
                    { name: 'Organic', id: 2, stype:'s' }
                ];
				return src;
            },
			// FILTER: PUBLISHER
			PublisherDropdownFilter() {
                let pbsh = [
                    { name: 'Indeed', pbid: "Indeed", ptype:'p' },
                    { name: 'Appcast', pbid: "Appcast", ptype:'p' },
					{ name: 'Adzuna CPC', pbid: "Adzuna CPC", ptype:'p' },
					{ name: 'Talroo', pbid: "Talroo", ptype:'p' },
					{ name: 'Getwork', pbid: "Getwork", ptype:'p' }
                ];
				return pbsh;
            },
			// FILTER: DEVICE
			DeviceDropdownFilter() {
                let dvc = [
                    { name: 'Mobile', did: "mobile", dtype:'d' },
                    { name: 'Desktop', did: "desktop", dtype:'d' }
				];
				return dvc;
            },
			// FILTER: COMPANY
            CompnayDropdownFilter() {
				let cmpny = [];
				this.companyUserList.forEach(um => {
					cmpny.push({
						"cid":um.uid,
						"name":um.company,
						"ctype":'c',
						"value": um.uid, 
						"text": um.company
					});
					// test
					/*this.array4.push(um.id);
					this.FilterByCount = this.FilterByCount + 1;*/
				});
				return cmpny.sort(function(a, b){ return (a.name > b.name) ? 1 : -1;});
			},
			// FILTER: BIND SOURCE, PUBLISHER, DEVICE AND COMPANY
            FilterByOfficesManagers() {
                this.checkboxDataWithFilterDropdown.push({
                    name:'Source',
                    list: this.SourceDropdownFilter(),
                },{
                    name:'Publisher',
                    list: this.PublisherDropdownFilter(),
                },{
                    name:'Device',
                    list: this.DeviceDropdownFilter(),
                },{
                    name:'Company',
                    list: this.CompnayDropdownFilter(),
                })
			},
			// ON CHANGE SOURCE EVENT FIRE
            checkFilterBySource(event) {
                if(event.target.checked == true) {
                    this.array1.push(event.target.value);
                    this.FilterByCount = this.FilterByCount + 1; 
                } else {
                    this.array1.splice(this.array1.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1; 
                } 
				// this.array1 = this.array1.map((i) => Number(i)) // ['2', '4'] to [2,4]
                //eslint-disable-next-line
				console.log("Source: array1", this.array1);
            },
			// ON CHANGE PUBLISHER EVENT FIRE
            checkFilterByPublisher(event) {
                if(event.target.checked == true) {
                    this.array2.push(event.target.value);
                    this.FilterByCount = this.FilterByCount + 1; 
                } else {
                    this.array2.splice(this.array2.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1; 
                } 
                //eslint-disable-next-line
				console.log("Publisher: array2", this.array2);
            },
			// ON CHANGE DEVICE EVENT FIRE
            checkFilterByDevice(event) {
                if(event.target.checked == true) {
                    this.array3.push(event.target.value);
                    this.FilterByCount = this.FilterByCount + 1; 
                } else {
                    this.array3.splice(this.array3.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1; 
                } 
                //eslint-disable-next-line
				console.log("Device: array3", this.array3);
            },
			// ON CHANGE COMPANY EVENT FIRE
			checkFilterByCompany(event) {
				if(event.target.checked == true) {
					if(this.selectOnlyTen <= 9) {
						this.selectOnlyTen = this.selectOnlyTen + 1;
						this.array4.push(event.target.value);
						this.FilterByCount = this.FilterByCount + 1; 
						/*var oncheckAdd = this.allusersData.find(uo1=> uo1.id === event.target.value);
						this.allusersObjectData.push(oncheckAdd);*/
					} else {
						event.target.checked = false;
						alert("Please select at a time 10 companies. You can't select more than 10.");
					} 
				} else {
					this.selectOnlyTen = this.selectOnlyTen - 1;
                    this.array4.splice(this.array4.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1; 
					/*this.allusersObjectData = this.allusersObjectData.filter(function(item) { 
						return item.id !== event.target.value; 
					});*/
					this.allusersDataTemp = this.allusersDataTemp.filter(function(item) { 
						return item.uid !== event.target.value; 
					});
				} 
				this.companySelectOrNot = true;
				//eslint-disable-next-line
				console.log("Company: array4", this.array4);
				//eslint-disable-next-line
				console.log("selectOnlyTen", this.selectOnlyTen);
				//eslint-disable-next-line
				console.log("allusersDataTemp", this.allusersDataTemp);


			},
			// DISPLAY PURPOSE
			getMonthName(monthNumber) {
				const date = new Date();
				date.setMonth(monthNumber);
				return date.toLocaleString('en-US', { month: 'long' });
			},
		},
		data() {
			var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
			var GetOnlyYear = date.getFullYear();
			return {

				companyUserList: [],
				companySelectOrNot: false,

				array1: [],
				array2: [],
				array3: [],
				array4: [],

				startDate: '',
				endDate:'',
				
				ThirdPoolProspectsCount:0,
				OrganicProspectsCount: 0,
				QuestionnaireProspectsCount: 0,
				InterviewsCount: 0,
				SumInterviewScore: 0,
				CountInterviewScore: 0,
				FinalInterviewAverage: 0,
				HiredCount: 0,

				countNewStages: 0,
				countContactedStages:0,
				countDevelopmentDoneStages:0,
				countPostInterviewStages:0,
				countPreInterviewStages:0,
				countOfferStages:0,
				countHiredStages:0,
				countLostStagesL:0,

				allusersData: [],
				allusersObjectData: [],
				filterallusersData: [],

				checkAuth: true,
				checkAuthLoader: false,
				strictWarning: false,
				form: {
					email: null,
					password: null,
					date_s:firstDay,
                    date_e:new Date(),
					s_date: firstDay,
					e_date: new Date(),
				},
				options11: {
                    multi: true,
                    groups: true,
                },
				error: null,
				FilterByCount:0,
				companyField: null,
				month: date.getMonth(),
				monthoptions: [
					{ value: null, text: 'Please Select Month' },
					{ value: 0, text: 'January' },
                    { value: 1, text: 'February' },
                    { value: 2, text: 'March' },
                    { value: 3, text: 'April' },
                    { value: 4, text: 'May' },
                    { value: 5, text: 'June' },
                    { value: 6, text: 'July' },
                    { value: 7, text: 'August' },
                    { value: 8, text: 'September' },
                    { value: 9, text: 'October' },
                    { value: 10, text: 'November' },
                    { value: 11, text: 'December ' },
				],
				year: GetOnlyYear,
				yearoptions: [
					{ value: null, text: 'Please Select Year' },
					{ value: 2025, text: '2025'},
					{ value: 2024, text: '2024'},
					{ value: 2023, text: '2023'},
					{ value: 2022, text: '2022'},
					{ value: 2021, text: '2021'},
					{ value: 2020, text: '2020'},
					{ value: 2019, text: '2019'},
					{ value: 2018, text: '2018'},
					{ value: 2017, text: '2017'},
					{ value: 2016, text: '2016'},
					{ value: 2015, text: '2015'},
					{ value: 2014, text: '2014'},
					{ value: 2013, text: '2013'},
					{ value: 2012, text: '2012' },
					{ value: 2011, text: '2011' },
				],
				projectedHire: 0,
				projectedHireField: '',
				
				prospectStageOptions: {
					title: {
                        text: 'Prospect Stages',
                        style: {
                            fontSize: '17px'
                        }
                    },
					chart: {
						type: 'bar',
						toolbar: {
							tools:{
								download:false // <== line to add
							}
						},
						height: 350
					},
					plotOptions: {
						bar: {
							borderRadius: 4,
							horizontal: true,
						}
					},
					dataLabels: {
						enabled: false
					},
					xaxis: {
						categories: ['New', 'Contacted', 'Development Done', 'Post-Interview Nurture', 'Pre-Interview Nurture', 'Offer', 'Hired', 'Lost to competitor'],
					}
				},
				prospectStageSeries: [{
					name: '',
					data: [0, 0, 0, 0, 0, 0, 0, 0]
				}],

				checkboxDataWithFilterDropdown: [],
				Phase1ProjectedHires: 0,
				
				pageLoader:true,
				filterClicked:false,
				CCICount:0,
				nickName:'',
				getCurrentCompanyDetail:[],

				PDFThirdPoolProspectsCount:0,
				PDFOrganicProspectsCount: 0,
				PDFSourceCount: 0,
				
				mPDFInterviewesCompleted: 0,
				mPDFIntervieweShowCompleted: 0,
				yPDFIntervieweShowCompleted: 0,
				mPDFAddedToPipeline: 0,
				mPDFLTCCount: 0,
				mPDFHiredCount: 0,

				yPDFInterviewesCompleted: 0,
				yPDFAddedToPipeline: 0,
				yPDFLTCCount: 0,
				yPDFHiredCount: 0,

				PDFTag1: 0,
				PDFTag2: 0,
				PDFTag3: 0,
				pTag1: 0,
				pTag2: 0,
				pTag3: 0,

				PDFAdCostYourCompany: 0,
				PDFStatusPreInt: 0,
				PDFStatusPostInt: 0,
				PDFStatusOff: 0,
				yPDFStatusPreInt: 0,
				yPDFStatusPostInt: 0,
				yPDFStatusOff: 0,
				PipePDFStatusPreInt: 0,
				PipePDFStatusPostInt: 0,
				PipePDFStatusOff: 0,

				PDFInterviewRateYour: 0,
				PDFHiredRateYour: 0,
				PDFLTCRateYour: 0,
				PDFInterviewNoShowRate: 0,
				// yPDFInterviewNoShowRate: 0,
				PDFSourcingCostYC: 0,
				makePDFFileName: '',

				myconvos: [],
				CheckUniqueInboundMessage: 0,
				sumOfInbound: 0,
				sumOfOutbound: 0,
				totalInboundMessageCount: 0,
				CheckUniqueOutBoundMessage: 0,
				totalOutBoundMessageCount: 0,
				isShowConvoAnalytics: false,
				isShowProspectsData: false,
				showProspectsData: false,

				convertselectedMonthFirstDay: 0,
				convertselectedMonthLastDay: 0,
				convertsetFirstJan: 0,
				AdCostNationalAverage: 0,
				SourcingCostNationalAverage: 0,

				yPDFNAHiredRate: 0,
				yPDFNALTCRate: 0,
				yPDFNAInterviewRate: 0,
				yPDFNAInterviewNoShowRate: 0,

				convoCollectionData: [],
				cUid: [],
				selectOnlyTen: 0,
				allusersDataTemp: [],
			}
        }
    }
</script>
<style scoped>
.tempBODY .row{
	margin:0px;
}
.authSection{
	padding: 8% 5%;
}
.AuthLoginBtn{
	text-align: center;
	margin-top: 30px;
}
.AuthLoginBtn .btn-outline-primary{
    padding: 10px 40px;
    height: 40px;
}
.assessmentdiv h4{
	padding: 20px;
    font-size: 20px;
    background-color: #e6e6e6;
    text-align: center;
	margin-bottom:0px;
}
.assessmentdiv {
	background: #fff;
    border-radius: 4px;
    box-shadow: 1px 2px 8px 1px #dde;
}
.assessmentdivbody{
    padding: 30px;
}
.AccessDeniedDiv h4{
	background: #f28080;
}
.AccessDeniedDiv .assessmentdivbody{
	font-size: 14px; 
	color: #868686;
}
.masterReportHead{
	padding: 12px;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    background: #dfdfdf;
    margin-bottom: 12px;
}
.masterReportTitle{
	padding: 12px;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 12px;
}
.tilesDiv .tatext-card-layout{
	padding: 12px 2px;
	box-shadow: 0 2px 10px -1px rgb(69 90 100 / 30%);
	height: 120px;
	transition: box-shadow .2s ease-in-out;
}
.tilesDiv .text-c-blue { 
	background-color: #06187c; 
	color: white;
}
.tilesDiv{
	margin-bottom: 30px;
}
.tilesDiv .tilesBodyDiv{
	padding: 10px;
}
.tilesDiv .tilesBodyDiv h3{
	position: absolute;
	bottom: 5px;
}
.select.multiSelectdiv .btn-select{
	padding: 6px 30px;
}
.createStartReport{
	padding: 5px 0px;
    margin-left: 10px!important;
    border-radius: 3px!important;
}
.GenerateReportDiv button{
	height: 40px;
    font-size: 14px;
}

.select.multiSelectdiv .btn-select{
    margin: 0px 15px;
    border-radius: 3px;
    color: #007bff;
    border-color: #007bff;
    padding: 5px 30px;
    background: transparent;
    font-size: 14px;
    line-height: 1.5;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}
.select.multiSelectdiv .btn-select:hover{
    background: #007bff;
    color:#fff;
}
.select.multiSelectdiv .btn-select:focus{
    outline:none;
    box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 50%);
}
.select.multiSelectdiv .checkBoxContainer{
    padding: 0px;
    margin: 0px;
}
.select.multiSelectdiv .checkBoxContainer .selectItem {
    padding: 8px;
    margin: 0px;
    font-size: 15px;
    border-bottom: 1px solid #ddd;
}
.select.multiSelectdiv .checkBoxContainer .selectItem:last-child {
    border:none;
}
.loader4 {
   width:24px;
   height:24px;
   display:inline-block;
   padding:0px;
   border-radius:100%;
   border:5px solid;
   border-top-color:#fff;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#fff;
   border-right-color:rgba(255,255,255, 0.3);
   -webkit-animation: loader4 1s ease-in-out infinite;
   animation: loader4 1s ease-in-out infinite;
}

.loader-blue .loader4{
    border-top-color:#06187c;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#06187c;display: flex;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
    bottom: 0;
   border-right-color:rgba(255,255,255, 0.3);
}
.loader-blue{
    position: absolute;
    padding-left: 0px;
    top: 0;z-index: 9999;
    margin: auto;
    bottom: 0;
}
@keyframes loader4 {
   from {transform: rotate(0deg);}
   to {transform: rotate(360deg);}
}
@-webkit-keyframes loader4 {
   from {-webkit-transform: rotate(0deg);}
   to {-webkit-transform: rotate(360deg);}
}
</style>
<style>
.selectItem{
	font-weight: normal!important;
	color: #000!important;
}
.select.multiSelectdiv .checkBoxContainer{
    min-height: auto;
}
.select .checkboxLayer {
    min-width: 485px!important;
}
input.nickNamefield, input.nickNamefield::placeholder{
	font-size: 12px;
}
</style>